const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const GainAPEvent = require('../../events/GainAPEvent');
const { logError } = require('../../logger');

const Adrenaline = function(battleState) {
  this.handle = 'adrenaline';
  this.physical = true;
  this.help = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = () => true;

  this.execute = function(actor, victim) {
    if (!actor || !actor.inPlay) {
      return;
    }

    try {
      var finalPotency = Math.floor(BattleCalc.getEquippedAbility(actor,'adrenaline').potency);
      if (finalPotency > actor.max_ap - actor.ap) {
        finalPotency = actor.max_ap - actor.ap;
      }

      const gainAP = new GainAPEvent(battleState, finalPotency);
      gainAP.execute(actor);
      gainAP.actorId = actor.uid;
      gainAP.victimId = actor.uid;

      var result = { gainAP };

      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'Adrenaline',
        func: 'execute',
        actor,
        victim,
      });
      return { success: false };
    }
  };
};
module.exports = Adrenaline;
